module.exports = __webpack_public_path__ + "img/about_elaine2.0ebb2787.png";